import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

import initialState from './initialState.js'

let state = initialState()

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
